export { default } from "./CardImage"
